import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import CircularProgress from 'material-ui/CircularProgress';
import { Table } from 'reactstrap';

class SessionDetails extends Component{
  constructor(props){
    super(props);
    const search = props.location.search; // returns the URL query String
    const params = new URLSearchParams(search);
    this.state = {
      fixture_id: params.get("fixture_id"),
      venue_id: params.get("venue_id"),
      date:params.get("day"),
      session_details:[],
      headers:[],
      loading:true
    }
  }

  componentDidMount() {
    this.getBatchDetails()
  }

  getBatchDetails(){
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=458721&fixture_id=${this.state.fixture_id}&venue_id=${this.state.venue_id}&day=${this.state.date}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({session_details:data.data,headers:data.headers,loading:false})
           // alert("fix");
       }).catch(error => error);
  }

  render(){
    console.log("state",this.state)
    return(
      <div>
        <div className="breadcrumps" style={{marginBottom:'2%'}}>
          <a href={'/#/dashboard/ActiveCustomer'} >
            <span>Dashboard</span>
          </a>
          <a href={'/#/dashboard/BatchHealth'} >
            <span>Batch Health</span>
          </a> 
          <a>
            <span>Session Details</span>
          </a>  
        </div>
        {
          this.state.loading ? 
            <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%'}}><CircularProgress /></div>
            </div>
          :
        
        <Table responsive style={{border:'1px solid rgb(101, 70, 138)'}}>
          <thead>
            <tr style={{backgroundColor:'rgb(101, 70, 138)',color:'white'}}>
              {/*
                this.state.headers.map(header=>(
                  this.state.batch_details[0][1] ==='Adults'   
                  ?
                    header != 'Subscription Overview' && <th> {header} </th>
                  : 
                  header != '# of games in last 30 days' && <th> {header} </th>
                ))
              */}
              {
                this.state.headers.map(header=>(
                  <th> {header} </th>
                ))
              }
            </tr>
          </thead>
          <tbody>
            {
              this.state.session_details.map((item,index)=>(
              	<tr>
              	{
              		item.map(x=>(
	              		<td dangerouslySetInnerHTML={{__html: x}}></td>
	              	))
              	}
              	</tr>
                
              ))
            }
          </tbody>
        </Table>
      }

      </div>
      )
  }

}

export default SessionDetails;


// WEBPACK FOOTER //
// ./src/app/views/centerportal/sessionDetails/index.js